var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightningBoltIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 19,
    viewBox: "0 0 14 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.08173 10.2142H3.97353V16.9523C3.97353 17.9443 5.20886 18.4123 5.86396 17.6636L12.9484 9.61521C13.5661 8.91332 13.07 7.81837 12.1342 7.81837H9.2424V1.08021C9.2424 0.0882014 8.00707 -0.379727 7.35197 0.368958L0.267539 8.41732C-0.340768 9.11921 0.155236 10.2142 1.08173 10.2142Z",
    fill: "#2E9E3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightningBoltIcon);
export default __webpack_public_path__ + "static/media/lightning-bolt-icon.4d83430d6baf3e69b6a89fdd75a65467.svg";
export { ForwardRef as ReactComponent };